import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { Toaster } from 'react-hot-toast';
import { AuthProvider, useAuth } from './context/AuthContext';
import Layout from './components/layout/Layout';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import Rooms from './pages/Rooms';
import Students from './pages/Students';
import Reservations from './pages/Reservations';
import Tenancies from './pages/Tenancies';
import Laundry from './pages/Laundry';
import Agreements from './pages/Agreements';
import LaundryPublic from './pages/LaundryPublic';
import Settings from './pages/Settings';
import AiChat from './pages/AiChat';

const Protected = ({ children }) => {
  const { user, loading } = useAuth();
  if (loading) return <div className="min-h-screen flex items-center justify-center text-gray-400">Loading...</div>;
  if (!user) return <Navigate to="/login" replace />;
  return <Layout>{children}</Layout>;
};

function AppRoutes() {
  const { user } = useAuth();
  return (
    <Routes>
      <Route path="/login" element={user ? <Navigate to="/" replace /> : <Login />} />
      <Route path="/" element={<Protected><Dashboard /></Protected>} />
      <Route path="/rooms" element={<Protected><Rooms /></Protected>} />
      <Route path="/students" element={<Protected><Students /></Protected>} />
      <Route path="/reservations" element={<Protected><Reservations /></Protected>} />
      <Route path="/tenancies" element={<Protected><Tenancies /></Protected>} />
      <Route path="/laundry" element={<Protected><Laundry /></Protected>} />
      <Route path="/agreements" element={<Protected><Agreements /></Protected>} />
      <Route path="/settings" element={<Protected><Settings /></Protected>} />
      <Route path="/ai-chat" element={<Protected><AiChat /></Protected>} />
      <Route path="/laundry/public/:token" element={<LaundryPublic />} />
    </Routes>
  );
}

export default function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <AppRoutes />
        <Toaster position="top-right" toastOptions={{ duration: 3000 }} />
      </BrowserRouter>
    </AuthProvider>
  );
}
